module.exports = __webpack_public_path__ + "static/media/Veterinaria.f9a6b5d2.jpg";